'use client';

import { useParams } from 'next/navigation';
import { useQuery } from '@apollo/client/react';
import Typography from '@mui/material/Typography';
import Loading from '@/components/loading';
import ErrorMessage from '@/components/error-message';
import NotFound from '@/components/not-found';
import EventList from '@/components/event-list';
import { groupPastEventsQuery } from '@/apollo/groups';
import GroupCalendarFooter from '@/components/groups/calendar-footer';
import CalendarHeader from '@/components/groups/calendar-header';

type Props = {
  initialGroup?: Record<string, unknown>;
};

const GroupCalendarPastPageClient = ({ initialGroup }: Props) => {
  const { slug } = useParams();

  const { data, loading, error } = useQuery(groupPastEventsQuery, {
    variables: { slug },
    ssr: false,
  });
  const group = data?.group || initialGroup;

  if (!group && loading) { return <Loading />; }
  if (error && !group) {
    return <ErrorMessage message='An error occurred while loading group.' error={error} />;
  }
  if (!group || group.found) { return <NotFound />; }

  return (
    <>
      <CalendarHeader title="Calendar" tab="past" group={group} />

      <Typography variant="h2">Past</Typography>

      <EventList
        events={group.pastEvents}
        group={group}
        emptyMessage={
          group.permissions.joined ? 'No past events' : 'No past public events'
        }
        fullDate
      />

      <GroupCalendarFooter group={group} />
    </>
  );
};

export default GroupCalendarPastPageClient;
